



//开发环节
const dev = {
 
//  TwoHttp:"http://192.168.1.183:9000",
TwoHttp:"http://system.hbjyjh.com:8081/jyjh/health-system",

}
//测试环节
const test = {
 TwoHttp:"http://192.168.1.183:9000",
}
//线上环节
const pro = {
  TwoHttp:"https://api.hbjyjh.com/gw/jyjh/health-system",
  // TwoHttp:"http://system.hbjyjh.com:8081/jyjh/health-system",
}

// ===== 资源地址配置（所有环境共用，按需修改） =====
const RES = {
  /** FastDFS 文件服务器前缀 */
  FDFS: 'https://api.hbjyjh.com/fdfs/',
  /** 蓝湖 OSS 切图前缀 */
  LANHU_OSS: 'https://lanhu.oss-cn-beijing.aliyuncs.com/',
  /** 手机端 H5 地址 */
  H5_URL: 'https://www.hbjyjh.com/h5/home-index',
  /** 官网主域名 */
  DOMAIN: 'https://www.hbjyjh.com',
}

function getApi() {
  if (process.env.NODE_ENV === 'development') {
    return dev
  } else if (process.env.NODE_ENV === 'test') {
    return test
  } else {
    return pro
  }
}

const api = getApi()
/** 全局变量在此处配置 */
export { api as default, RES }


